module.exports = __webpack_public_path__ + "static/media/megaphone.069939c8.png";